<template>
  <section class="col-12 col-md-8 mt-2">
    <div class="row border-bottom font-weight-bold">
      <div class="col-8 py-1" v-html="constructionTitle" />
      <div class="col-4 py-1" v-html="constructionValueTitle" />
    </div>
    <div class="row border-bottom" v-for="(part, index) in composition" :key="index">
      <div class="col-8 py-1" v-html="part.title.de" />
      <div class="col-4 py-1" v-html="part.output" />
    </div>
    <div class="row font-weight-bold">
      <div class="col-8 py-1" v-html="constructionSum" />
      <div class="col-4 py-1" v-html="construction.sum.output" />
    </div>
  </section>
</template>

<script>

import { getString } from '../../../language'

export default {
  name: 'StoCscResultItemComposition',
  props: {
    construction: Object
  },
  data: function () {
    return {
      constructionTitle: getString('result.construction.title'),
      constructionValueTitle: getString('result.construction.valueTitle'),
      constructionSum: getString('result.construction.sum')
    }
  },
  computed: {
    composition () {
      return this.construction.composition.filter(obj => obj.output !== null)
    }
  }
}

</script>
